export default {
    empty: {
        title: 'Unfortunately there weren\'t any matching results.',
        content: 'Visit our page with information on <a href="https://support.trendmanager.com/en/help-topic/tips-on-trend-searching/" target="_blank">trend searching</a>.'
    }
}
